/** Created by azhou on 2019/3/18.*/
<template>
    <div>
      <public-title>账号设置</public-title>
      <div class="load-area">
        <el-tabs v-model="activeName">
          <el-tab-pane :label="item.name" :name="item.val" :key="item.name" v-for="(item,index) in tabArr" v-if="!isGroup"/>
          <el-tab-pane :label="item.name" :name="item.val" :key="item.name" v-for="(item,index) in tabArr" v-if="isGroup&&index==0"/>
        </el-tabs>
        <pwd-set class="w-75 m-auto pt-4" v-show="activeName === 'password'" />
        <phone-set class="w-75 m-auto pt-4" v-show="activeName === 'phone'"/>
        <wechat-set class="w-75 m-auto pt-4" v-if="activeName === 'wechat'"/>
        <email-set class="w-75 m-auto pt-4" v-show="activeName === 'email'"/>
      </div>
    </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import PwdSet from './PwdSet'
  import PhoneSet from './PhoneSet'
  import WechatSet from './WechatSet'
  import EmailSet from './EmailSet'

  export default {
    name: 'AccountSet',
    components:{ PwdSet,PhoneSet,WechatSet,EmailSet },
    computed: {
      ...mapGetters(['storeInfo','isGroup']),
      activeType() { return this.$route.query.type }
    },
    data() {
      return {
        tabArr:[
          {name:'密码设置',val:'password'},
          {name:'手机绑定',val:'phone'},
          {name:'微信绑定',val:'wechat'},
          // {name:'邮箱绑定',val:'email'},
        ],
        activeName:'password'
      }
    },
    created() {
      if (this.activeType) this.activeName = this.activeType;
    },
    watch:{
      activeType(newVal) { this.activeName = newVal; },
      activeName(newVal) { this.$router.push({name:this.$route.name,query:{type:newVal}}, ()=>{}, ()=>{}) }
    }
  }
</script>
